// import store from "./store";

// Only the slices listed here survive a page reload. PBICred/PBILoaded are
// re-fetched on every dashboard mount, so persisting them just preserves
// stale/transient data (including failed-fetch states) across reloads.
const PERSISTED_KEYS = ["authUser"];

export default class StateLoader {
  loadState() {
    try {
      let serializedState = window.sessionStorage.getItem("localStateName");

      if (serializedState === null) {
        return this.initializeState();
      }

      return JSON.parse(serializedState);
    } catch (err) {
      return this.initializeState();
    }
  }

  saveState(state) {
    let persistedState = {};
    PERSISTED_KEYS.forEach((key) => {
      if (state[key] !== undefined) {
        persistedState[key] = state[key];
      }
    });
    let serializedState = JSON.stringify(persistedState);
    window.sessionStorage.setItem("localStateName", serializedState);
  }

  initializeState() {
    return {};
  }
}
